import {
  Anchor,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Input,
  Select,
} from "@mantine/core";
import { IconMail, IconPencil } from "@tabler/icons-react";
import { apiUserGetProducts, apiUserGetWarehouses } from "@/api";
import { useEffect, useState } from "react";

import { orpcClient } from "@/lib/orpc-client";
import { single, allOrThrow } from "@/lib/orpc-batch";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

function EditInventoryDoneListPage() {
  const [inventoryDoneData, setInventoryDoneData] = useState({
    company: localStorage.getItem("companyId"),
    name: "",
    remarks: "",
    productList: [],
    deliveryPerson: "",
    licensePlateNumber: "",
    warehouseStaff: "18",
  });
  const [editInventoryDoneData, setEditInventoryDoneData] = useState({});
  const [tempProductList, setTempProductList] = useState([]);
  const [tempProductData, setTempProductData] = useState([]);
  const [tempProductInput, setTempProductInput] = useState([]);
  const [tempWarehouseData, setTempWarehouseData] = useState([]);
  const [tempWarehouseInput, setTempWarehouseInput] = useState([]);
  const [tempStorageLocationInput, setTempStorageLocationInput] = useState([]);
  const [tempAmount, setTempAmount] = useState([]);
  const [disable, setDisable] = useState([]);

  const [deleteProductList, setDeleteProductList] = useState([]);

  const { id } = useParams();

  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const navigate = useNavigate();

  const handleSubmit = async (
    editInventoryDoneData,
    tempProductList,
    deleteProductList
  ) => {
    try {
      if (Object.keys(editInventoryDoneData)?.length) {
        await single(
          orpcClient.stockReceipt.update([
            {
              id: id!,
              ...editInventoryDoneData,
            },
          ])
        );
      }

      if (deleteProductList?.length) {
        await allOrThrow(
          orpcClient.stockReceiptProduct.delete(
            deleteProductList.map((productId) => ({ id: productId }))
          )
        );
      }

      let editTempProductList = [];

      let newTempProductList = [];

      tempProductList?.map((t) => {
        if (t?.id) {
          editTempProductList.push(t);
        } else {
          newTempProductList.push(t);
        }
      });

      if (editTempProductList?.length) {
        await allOrThrow(
          orpcClient.stockReceiptProduct.update(
            editTempProductList.map((data) => ({
              id: data?.id,
              stockReceiptId: id,
              amount: data?.amount,
            }))
          )
        );
      }

      if (newTempProductList?.length) {
        await allOrThrow(
          orpcClient.stockReceiptProduct.create(
            newTempProductList.map((data) => ({
              amount: data?.amount,
              productId: data?.product?.id,
              stockReceiptId: id!,
              storageLocationId: data?.storageLocation,
            }))
          )
        );
      }
    } catch (error) {
      console.error("api error", error);
      return;
    }
    navigate(`/hrMainPage/inventoryDone/${id}`);
  };

  const handleDataChange = (name, value) => {
    setInventoryDoneData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setEditInventoryDoneData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDeleteProductList = (index, id) => {
    const updatedProductList = [...tempProductList];

    updatedProductList.splice(index, 1);

    setTempProductInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempWarehouseInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempStorageLocationInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempAmount((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setDisable((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempProductList(updatedProductList);

    //新增的不用call delete API
    if (id) {
      setDeleteProductList((prev) => [...prev, id]);
    }
  };

  const handleOnOptionSubmit = (type, e, data, index) => {
    let selectedData;
    if (type === "product") {
      selectedData = data.filter((item) => item?.name === e)[0];
      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = { ...updatedList[index], [type]: selectedData };
        return updatedList;
      });
    } else {
      let idBehindMatch = e.match(/ID:\s*([a-zA-Z0-9]+)/);
      let documentID = idBehindMatch ? idBehindMatch[1].trim() : null;

      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = {
          ...updatedList[index],
          storageLocation: documentID,
        };
        return updatedList;
      });
    }
  };

  const handleAddProductList = (productList) => {
    const updatedProductList = [...productList, []];

    setTempProductList(updatedProductList);
    setDisable((prev) => {
      return [...prev, false];
    });
  };

  const handleDisplaySelectMembers = (data) => {
    return data?.map((t) => ({ value: t?.id, label: t?.name }));
  };
  const handleDisplaySelectWarehouse = (data) => {
    return data?.map((t) => {
      return `倉庫： ${t?.name},  ID: ${t?.id}`;
    });
  };

  const handleDisplaySelectStorageLocation = (
    warehouseInput,
    warehouseData
  ) => {
    if (!warehouseInput) return;

    let match = warehouseInput?.match(/ID:\s*(\d+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = warehouseData.filter((e) => e?.id == idNumber)[0];

    if (selectedData?.storageLocations) {
      return selectedData?.storageLocations.map(
        (location) =>
          `儲位： ${location?.name}    , ID: ${location?.documentId}`
      );
    } else {
      return;
    }
  };

  const {
    // company,
    name,
    remarks,
    deliveryPerson,
    licensePlateNumber,
    warehouseStaff,
    // contact,
    // storage_locations,
  } = inventoryDoneData || {};
  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await single(orpcClient.stockReceipt.read([{ id: id! }]));
        if (!result) return;
        const productList = await orpcClient.stockReceiptProduct.list({
          filter: { stockReceiptId: id },
        });

        setInventoryDoneData(result);

        setTempProductList(
          productList.map((item) => {
            const {
              id,
              amount,
              createdAt,
              updatedAt,
              stockReceiptId,
              productId,
              storageLocationId,
            } = item;

            return {
              id,
              amount,
              createdAt,
              updatedAt,
              stockReceiptId,
              productId,
              storageLocationId,
            };
          })
        );

        setTempProductInput(productList?.map((item) => item?.product?.id));
        setTempWarehouseInput(
          productList?.map((item) => {
            return `倉庫： ${result?.name},  ID: ${result?.id}`;
          })
        );
        setTempStorageLocationInput(
          productList?.map((item) => {
            return `儲位： ${item?.storageLocation?.name}    , ID: ${item?.storageLocation?.id}`;
          })
        );

        setTempAmount(productList?.map((item) => item?.amount));

        setDisable(productList?.map(() => true));
      } catch (error) {
        console.error("Error fetching stock receipt data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetProducts();

        setTempProductData(result?.data);
      } catch (error) {
        console.error("Error fetching apiUserGetProducts data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetWarehouses();

        setTempWarehouseData(result?.data);
      } catch (error) {
        console.error("Error fetching apiUserGetProducts data:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="py-3 text-6xl font-bold" style={{ color: "#6F6F6F" }}>
            編輯入庫單
          </div>

          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            基本資訊
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>入庫單名稱</div>
              <Input
                value={name}
                onChange={({ target: { value } }) =>
                  handleDataChange("name", value)
                }
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
              />
            </div>
          </div>
          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            商品清單
          </div>
          <div className="flex justify-center">
            <Button
              variant="default"
              style={{ maxWidth: "250px", width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => handleAddProductList(tempProductList)}
            >
              增加商品列
            </Button>
          </div>
          {tempProductList.map((t, i) => {
            return (
              <div className="flex items-center justify-start">
                <div className="">
                  <div style={{ color: "#6F6F6F" }}>商品名稱</div>
                  <Select
                    searchable
                    nothingFoundMessage="查無資料"
                    disabled={disable[i]}
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectMembers(tempProductData)}
                    value={tempProductInput[i] || null}
                    onChange={(value) => {
                      setTempProductInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      });
                      const selectedData = tempProductData.find(
                        (p) => p?.id === value
                      );
                      setTempProductList((prev) => {
                        const updated = [...prev];
                        updated[i] = {
                          ...updated[i],
                          product: selectedData,
                        };
                        return updated;
                      });
                    }}
                  />
                </div>

                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>倉庫</div>
                  <Autocomplete
                    disabled={disable[i]}
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectWarehouse(tempWarehouseData)}
                    value={tempWarehouseInput[i] || ""}
                    onChange={(value) => {
                      setTempWarehouseInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      });

                      setTempStorageLocationInput((prev) => {
                        const updated = [...prev];
                        updated[i] = [];
                        return updated;
                      });
                    }}
                  />
                </div>

                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>儲位</div>
                  <Autocomplete
                    disabled={disable[i]}
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectStorageLocation(
                      tempWarehouseInput[i],
                      tempWarehouseData
                    )}
                    value={tempStorageLocationInput[i] || ""}
                    onChange={(value) =>
                      setTempStorageLocationInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      })
                    }
                    onOptionSubmit={(e) => {
                      handleOnOptionSubmit(
                        "warehouse",
                        e,
                        tempWarehouseData,
                        i
                      );
                    }}
                  />
                </div>
                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>數量</div>
                  <Input
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    value={tempAmount[i] || ""}
                    onChange={(e) => {
                      setTempProductList((prev) => {
                        const updatedList = [...prev];
                        updatedList[i] = {
                          ...updatedList[i],
                          amount: e.target.value,
                        };
                        return updatedList;
                      });

                      setTempAmount((prev) => {
                        const updated = [...prev];
                        updated[i] = e.target.value;
                        return updated;
                      });
                    }}
                  />
                </div>
                <Button
                  variant="filled"
                  color="red"
                  style={{ width: "100%", maxWidth: "100px", margin: "1rem" }}
                  radius="md"
                  onClick={() => handleDeleteProductList(i, t?.documentId)}
                >
                  刪除
                </Button>
              </div>
            );
          })}

          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            交貨資訊
          </div>

          <div className="py-4">
            <div className="flex items-center justify-start">
              <div className="">
                <div style={{ color: "#6F6F6F" }}>送貨人員</div>
                <Input
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  value={deliveryPerson}
                  onChange={(e) =>
                    handleDataChange("deliveryPerson", e.target.value)
                  }
                />
              </div>
              <div className=" pl-2">
                <div style={{ color: "#6F6F6F" }}>送貨車牌</div>
                <Input
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  value={licensePlateNumber ?? ""}
                  onChange={(e) =>
                    handleDataChange("licensePlateNumber", e.target.value)
                  }
                />
              </div>
              <div className=" pl-2">
                <div style={{ color: "#6F6F6F" }}>入庫人員</div>
                <Input
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  value={warehouseStaff?.name}
                  onChange={(e) =>
                    handleDataChange("warehouseStaff", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>備註</div>
              <Input
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
                value={remarks}
                onChange={(e) => handleDataChange("remarks", e.target.value)}
              />
            </div>
          </div>

          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => navigate(`/hrMainPage/inventoryDone`)}
            >
              取消
            </Button>

            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() =>
                handleSubmit(
                  editInventoryDoneData,
                  tempProductList,
                  deleteProductList
                )
              }
            >
              編輯
            </Button>
          </div>
        </>
      </div>
    </div>
  );
}
export default EditInventoryDoneListPage;
